const Builder = require('../BuilderBase');

module.exports = class MappedBooleanColumn extends Builder {
    constructor(title, properties) {
        super('listColumn_MappedBoolean', title, properties);
    }
};
